import PropTypes from 'prop-types';

import { RE_DIGIT } from '@shared/constants';
import { useMemo } from 'react';

import styles from './CustomOTPInput.module.scss';
import CustomText from '../CustomText';

const CustomOTPInput = ({ error, value, valueLength, onChange }) => {
  const valueItems = useMemo(() => {
    const valueArray = value.split('');
    const items = [];

    for (let i = 0; i < valueLength; i++) {
      const char = valueArray[i];

      if (RE_DIGIT.test(char)) items.push(char);
      else items.push('');
    }

    return items;
  }, [value, valueLength]);

  const focusNextInput = target => {
    const nextElementSibling = target.nextElementSibling;

    if (nextElementSibling) nextElementSibling.focus();
  };

  const focusPreviousInput = target => {
    const previousElementSibling = target.previousElementSibling;

    if (previousElementSibling) previousElementSibling.focus();
  };

  const inputOnChange = (e, idx) => {
    let targetValue = e.target.value.trim();
    const isTargetValueDigit = RE_DIGIT.test(targetValue);

    if (!isTargetValueDigit && targetValue !== '') return;

    targetValue = isTargetValueDigit ? targetValue : ' ';

    const targetValueLength = targetValue.length;

    if (targetValueLength === 1) {
      const newValue =
        value.substring(0, idx) + targetValue + value.substring(idx + 1);

      onChange(newValue);

      if (!isTargetValueDigit) return;

      focusNextInput(e.target);
    } else if (targetValueLength === valueLength) {
      onChange(targetValue);
    }
  };

  const inputOnKeyDown = e => {
    e.target.setSelectionRange(0, e.target.value.length);

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      focusNextInput(e.target);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      focusPreviousInput(e.target);
    }

    if (e.key !== 'Backspace' || e.target.value !== '') return;

    focusPreviousInput(e.target);
  };

  const inputOnFocus = e => {
    e.target.setSelectionRange(0, e.target.value.length);
  };

  return (
    <div className={styles.container}>
      <div className={styles.inputContainer}>
        {valueItems.map((digit, index) => (
          <input
            key={index}
            type='text'
            inputMode='numeric'
            autoComplete='one-time-code'
            pattern='\d{1}'
            maxLength={valueLength}
            className={styles.input}
            value={digit}
            onChange={e => inputOnChange(e, index)}
            onKeyDown={inputOnKeyDown}
            onFocus={inputOnFocus}
            autoFocus={index === 0 && true}
          />
        ))}
      </div>
      {error && (
        <div className={styles.errorContainer}>
          <CustomText className={styles.errorText}>{error}</CustomText>
        </div>
      )}
    </div>
  );
};

CustomOTPInput.propTypes = {
  error: PropTypes.string,
  value: PropTypes.string,
  valueLength: PropTypes.number,
  onChange: PropTypes.func,
};

export default CustomOTPInput;
